import request from "~/utils/http";

const attributeApi =
{
	get : async (id) =>
	{
		const url = `attribute/detail/${id}`;
		return await request.get(url);
	},
	gets : async (params) =>
	{
		const url = 'attribute';
		return await request.get(url, {params});
	},
	options : async (params) =>
	{
		const url = 'attribute';
        const paramsWidthOption = {
            ...params,
            options: true,
        };
        return await request.get(url, {params: paramsWidthOption});
	},
	add : async (params) =>
	{
		const url = 'attribute';
		return await request.post(url, params);
	},
	update : async (params) =>
	{
		const url = `attribute/${params.id}`;
		return await request.post(url, params);
	},
	delete : async (id) =>
	{
		const url = `attribute/delete/${id}`;
		return await request.delete(url);
	},
};

export default attributeApi;
